import { memo } from "react"

const IconError = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3987_10344)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6Z"
          fill="#ED4040"
        />
        <path
          d="M8.11781 7.62886C8.29359 7.79976 8.29359 8.07661 8.11781 8.24751C8.03062 8.33296 7.91531 8.37534 7.8 8.37534C7.68469 8.37534 7.56966 8.33262 7.48191 8.24717L6 6.80718L4.51823 8.24683C4.43034 8.33296 4.31517 8.37534 4.2 8.37534C4.08483 8.37534 3.9698 8.33296 3.88184 8.24683C3.70605 8.07593 3.70605 7.79907 3.88184 7.62817L5.36402 6.18716L3.88184 4.74683C3.70605 4.57593 3.70605 4.29907 3.88184 4.12817C4.05762 3.95728 4.34238 3.95728 4.51816 4.12817L6 5.56987L7.48219 4.12886C7.65797 3.95796 7.94273 3.95796 8.11852 4.12886C8.2943 4.29976 8.2943 4.57661 8.11852 4.74751L6.63633 6.18852L8.11781 7.62886Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3987_10344">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(IconError)
